import { RouteObject } from "react-router-dom";
import {BillCorrectionForm} from "./create/BillCorrectionForm";
import CorrectionList from "./landing/CorrectionList";
export interface BillCorrectionRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: BillCorrectionRoute[];
}
export const billCorrectionRoutes: BillCorrectionRoute[] = [
  {
    path: "/bx/bill-generation/bill-correction/correct-bill",
    element: <BillCorrectionForm />
  },
  {
    path: "/bx/bill-generation/bill-correction",
    element: <CorrectionList />
  },
];
